import { createFileRoute } from "@tanstack/react-router";

import {
  getProductPaymentsPageQuery,
  productPaymentsSearchSchema,
} from "src/helpers/productPaymentsPageQuery";
import { AthletePaymentsPage } from "src/pages/AthletePaymentsPage";
import { myProductSubscriptionsQueryOptions } from "src/queries/productSubscriptions";

export const Route = createFileRoute("/_auth/_athlete/payments")({
  component: AthletePaymentsPage,
  validateSearch: productPaymentsSearchSchema,
  ssr: true,
  loaderDeps: ({ search }) => {
    return getProductPaymentsPageQuery(search);
  },
  async loader({ context, deps }) {
    return context.queryClient.query({
      ...myProductSubscriptionsQueryOptions(deps),
      staleTime: "static",
    });
  },
  staticData: {
    getBreadcrumb(ctx) {
      return {
        href: "/payments",
        label: ctx.i18n.t("myPayments.title"),
      };
    },
  },
});
